import { IReservationsParams } from "../types";
import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IClassEventReservation } from "../../models/ClassEventReservation";
import { ClassEventReservationService } from "../../services/class-event-reservation.service";

export const useGetAllReservationsQuery = (data: IReservationsParams) => {
  return useQuery<IClassEventReservation[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_RESERVATIONS, data],
    queryFn: () => ClassEventReservationService.getAll(data).then((res) => res.data),
  });
};
